import { useContext } from 'react';
import { AuthContext } from '../../contextos/authContext';

import { MENU } from './menu'

import MenuRender from './MenuRender';
import SpinnerLoading from '../SpinnerLoading';


function Menu() {

    const { signed, loading, permissoes, superUser } = useContext(AuthContext);   

    function filtraMenuPorPermissoes(menu, permissoes) {
        return menu.map(secao => {
            const submenusFiltrados = secao.submenus.filter(sub =>
                !sub.acceptedRoles || sub.acceptedRoles.some(p => permissoes.includes(p))
            );

            return {
                ...secao,
                submenus: submenusFiltrados
            };
        })
            .filter(secao => secao.submenus.length > 0); // remove menus sem submenus visíveis
    }

    let menusPrivadosFiltradoPorPermissao = [];
    if (superUser) {
        menusPrivadosFiltradoPorPermissao = MENU.privado; // super user vê tudo
    } else {
        menusPrivadosFiltradoPorPermissao = filtraMenuPorPermissoes(MENU.privado, permissoes);
    }

    if (loading) {
        return (
            <div style={{ 'backgroundColor': '#f0eded' }}>
                <SpinnerLoading mensagemLoading='Carregando informações do usuário' />
            </div>
        );
    }

    // se estiver logado, junta as informações de rotas publicas com as rotas privadas, com base no perfil do usuario
    const botoesERotas = signed
        ? [...menusPrivadosFiltradoPorPermissao, ...MENU.publico]
        : MENU.publico;

    return (
        <MenuRender botoesERotas={botoesERotas} />
    );
}

export default Menu;
